module.exports = __webpack_public_path__ + "static/img/top3-img.340d368.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/top3-img.png
// module id = CxMP
// module chunks = 1